import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import bootbox from 'bootbox';
import Logo from '../../assests/logo.png';

function ResetForm({ history }) {
  let serverUrl = process.env.REACT_APP_SERVER_URL;
  const [loading, setLoading] = useState(false);

  const [send, setSend] = useState(false);
  const [phone, setPhone] = useState(null);

  const [isVerification, setIsVerification] = useState(false);

  const { register, handleSubmit, errors, watch } = useForm();

  const [showPass, setShowPass] = useState(false);

  const togglePassword = () => {
    setShowPass(!showPass);
  };

  let watchPass = watch('password');

  const handleOtpSend = async (data) => {
    try {
      await axios({
        method: 'post',
        url: `${serverUrl}/auth/request-otp`,
        data: data,
      }).then((res) => {
        setIsVerification(true);
        setSend(true);
      });
    } catch (error) {
      let response = error.response && error.response;
      let data = response && response.data;
      let message = data && data.message;
      bootbox.alert(message || 'Something went wrong');
    }
  };

  const submitForm = async (data) => {
    setLoading(true);
    axios({
      method: 'post',
      url: `${serverUrl}/auth/resetPass`,
      data: { ...data, phone },
    })
      .then((res) => {
        setLoading(false);
        bootbox.alert(res.data.message);
        history.replace('/login');
      })
      .catch((err) => {
        setLoading(false);
        bootbox.alert(err.response.data.message);
      });
  };

  const [timer, setTimer] = useState(30);
  const [endTime, setEndTime] = useState(null);

  useEffect(() => {
    if (timer === 30) {
      // Set the end time when timer starts
      setEndTime(Date.now() + 30000);
    }
  }, [timer]);

  useEffect(() => {
    if (!endTime) return;

    const interval = setInterval(() => {
      const remaining = Math.round((endTime - Date.now()) / 1000);
      setTimer(remaining > 0 ? remaining : 0);
    }, 1000);

    return () => clearInterval(interval);
  }, [endTime]);

  const resetTimer = () => {
    setTimer(30);
    setEndTime(null);
  };

  useEffect(() => {
    if (!isVerification) return;
    if (isVerification) {
      resetTimer();
    }
  }, [isVerification]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <form className="authForm" id="loginForm" onSubmit={send ? handleSubmit(submitForm) : handleSubmit(handleOtpSend)}>
      <div className="instructions__login">
        <div className="overlay__img d-sm-none" style={{ marginTop: '-120px', marginBottom: '50px' }}>
          <Link to="/">
            <img style={{ position: 'relative', width: '90px' }} alt="cedep Logo" src={Logo} />
          </Link>
          <br />
          <br />
        </div>

        <h2 className="Welcom pb-0 mb-2">Reset Password?</h2>
        {!send ? (
          <p className="small text-muted pl-1">
            We will send you an OTP to your email or phone number. Please enter the OTP to reset your password.
          </p>
        ) : (
          <p className="small text-muted pl-1">Enter the new password along with the otp you want to change.</p>
        )}
      </div>

      <>
        <div className={errors.phone ? 'errorfield inputGroup' : 'inputGroup'}>
          <input
            ref={register({
              required: 'Email or Phone number is required',
              pattern: {
                value: /^9\d{9}|[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                message: 'Invalid email or phone number',
              },
            })}
            onChange={(e) => {
              setPhone(e.target.value);
            }}
            disabled={send}
            name="phone"
            type="text"
            id="phone"
            placeholder="Email or Phone number"
          />
          <label className="input-icon-label" htmlFor="email">
            <i className="fas fa-mobile-alt"></i>
          </label>
        </div>
        <div className="input-error">{errors.phone && errors.phone.message}</div>

        {send && (
          <>
            <div className={errors.token ? 'errorfield inputGroup' : 'inputGroup'}>
              <input
                ref={register({ required: 'Otp code is required' })}
                name="token"
                type="text"
                id="token"
                placeholder="Otp code"
              />
              <label className="input-icon-label" htmlFor="token">
                <i className="fas fa-mobile-alt"></i>
              </label>
            </div>
            <div className="input-error">{errors.token && errors.token.message}</div>

            <div className={errors.password ? 'errorfield inputGroup' : 'inputGroup'}>
              <input
                ref={register({
                  required: 'Password is required',
                  pattern: {
                    value: /^.{6,}$/,
                    message: 'Password must have at least 6 characters',
                  },
                })}
                name="password"
                type={showPass ? 'text' : 'password'}
                id="password"
                placeholder="New Password"
              />
              <label className="input-icon-label" htmlFor="email">
                <i className={`fa ${showPass ? 'fa fa-eye-slash' : 'fa fa-eye'}`} onClick={togglePassword}></i>
              </label>
            </div>
            <div className="input-error">{errors.password && errors.password.message}</div>

            <div className={errors.password ? 'errorfield inputGroup' : 'inputGroup'}>
              <input
                ref={register({
                  required: 'Confirm Password is required',
                  validate: (value) => {
                    return value === watchPass || 'Password does not match!';
                  },
                })}
                name="confirm"
                type={showPass ? 'text' : 'password'}
                id="confirm"
                placeholder="Confirm Password"
              />
              <label className="input-icon-label" htmlFor="email">
                <i className={`fa ${showPass ? 'fa fa-eye-slash' : 'fa fa-eye'}`} onClick={togglePassword}></i>
              </label>
            </div>
            <div className="input-error">{errors.confirm && errors.confirm.message}</div>
          </>
        )}
      </>

      {send && (
        <div className="inputGroup pt-3 pb-3 center-block">
          <p className="text-muted small">
            Didn’t receive the OTP?{' '}
            <p
              className="text-muted small"
              onClick={() => {
                timer === 0 && handleOtpSend({ phone: watch('phone') });
                setIsVerification(false);
              }}
            >
              Resend OTP&nbsp;
            </p>
            {timer > 0 ? ` in ${timer > 0 && formatTime(timer)}` : ''}
          </p>
        </div>
      )}
      <div className="inputGroup pt-3 pb-3 center-block">
        <button type="submit" id="login" className="btn btn-dark rounded shadow register modified">
          {loading ? 'Loading...' : send ? 'Reset Password' : 'Request OTP'}
        </button>
        <Link to="/login">
          <button className="btn btn-dark rounded shadow d-block mt-3" id="register">
            Go back to login&nbsp;<i className="fas fa-arrow-circle-left"></i>
          </button>
        </Link>
      </div>
    </form>
  );
}

export default withRouter(ResetForm);
